import type {
	Components,
} from '@mui/material'

export const materialUIDialogTheme: {
	components: Components
} = {
	components: {
		MuiDialog: {
			styleOverrides: {
				paper: {
					backgroundColor: 'var(--surface-container-color)',
				},
				paperFullWidth: {
				},
			},
		},

		MuiDialogTitle: {
			styleOverrides: {
				root: {
					padding:      'var(--base-spacing-2)',
					borderBottom: 'var(--outline-base)',
					lineHeight:   1,
				},
			},
		},

		MuiDialogContent: {
			styleOverrides: {
				root: {
					padding: 'var(--base-spacing-2)',
				},
			},
		},

		MuiDialogActions: {
			styleOverrides: {
				root: {
					borderTop: 'var(--outline-base)',
				},
			},
		},

		MuiDrawer: {
			styleOverrides: {
				paper: {
					backgroundColor: 'var(--surface-container-color)',
				},
			},
		},
	},
}
